var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cve-version-table-cell"},[_c('v-chip',{staticClass:"chip",attrs:{"x-small":"","label":"","outlined":"","text-color":"black"}},[_vm._v(" "+_vm._s(_vm.version)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }